module.exports = require("@swa-ui/vacations/src/VacationsBookingForm/TravelerSelector/DropdownTrigger/DropdownTrigger.module.scss");